var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66537 1.27337L8.72536 0.333374L4.9987 4.06004L1.27203 0.333374L0.332031 1.27337L4.0587 5.00004L0.332031 8.72671L1.27203 9.66671L4.9987 5.94004L8.72536 9.66671L9.66537 8.72671L5.9387 5.00004L9.66537 1.27337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCross);
export default __webpack_public_path__ + "static/media/switch-cross.f9ebf56144c1201438b16323dc5cf29c.svg";
export { ForwardRef as ReactComponent };